function toEmbed(url) {
  try {
    const u = new URL(url);
    const host = u.hostname.replace("www.", "");
    if (host.includes("youtube.com")) {
      const id = u.searchParams.get("v");
      return { type: "iframe", src: `https://www.youtube.com/embed/${id}` };
    }
    if (host.includes("youtu.be")) {
      return { type: "iframe", src: `https://www.youtube.com/embed/${u.pathname.slice(1)}` };
    }
    if (host.includes("vimeo.com")) {
      const id = u.pathname.split("/").filter(Boolean)[0];
      return { type: "iframe", src: `https://player.vimeo.com/video/${id}` };
    }
    if (/\.(mp4|webm|ogg)$/i.test(u.pathname)) return { type: "video", src: url };
    return { type: "iframe", src: url };
  } catch {
    return { type: "iframe", src: url };
  }
}

export default function VideoEmbed({ url, className = "" }) {
  if (!url) return null;
  const embed = toEmbed(url);
  return (
    <div
      data-testid="video-embed"
      className={`relative w-full overflow-hidden rounded-md border border-[color:var(--ink-hairline)] bg-black ${className}`}
      style={{ aspectRatio: "16 / 9" }}
    >
      {embed.type === "iframe" ? (
        <iframe
          src={embed.src}
          title="video"
          className="absolute inset-0 h-full w-full"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      ) : (
        <video src={embed.src} controls className="absolute inset-0 h-full w-full" />
      )}
    </div>
  );
}
